import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import SupportHero from './components/SupportHero';
import ChannelCards from './components/ChannelCards';
import FAQAccordion from './components/FAQAccordion';
import ContactForm from './components/ContactForm';

export default function Support() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        <SupportHero />
        <ChannelCards />
        <FAQAccordion />
        <ContactForm />
      </main>
      <Footer />
    </div>
  );
}
